{
  "version": 1,
  "asset_id": "59308fdb-d9d5-4572-8d86-e47561c9600c",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/59308fdb-d9d5-4572-8d86-e47561c9600c/hiatal-normal-v3-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/59308fdb-d9d5-4572-8d86-e47561c9600c/hiatal-normal-v3-800.jpg",
  "original_filename": "hiatal-normal-v3-800.jpg",
  "size": 117808,
  "content_type": "image/jpeg",
  "created_at": "2026-10-28T23:12:07Z"
}
